<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/text';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-spectrum/text/package.json';

```jsx import
import {Text} from '@react-spectrum/text';
```

---
category: Content
---

# Text

<p>{docs.exports.Text.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Text']} />

## Example

```tsx example
<Text>Paste</Text>
```

## Content

The `Text` component represents text with no specific semantic meaning
within a Spectrum container such as a [Button](Button.html) or [Menu](Menu.html).
`Text` provides no styling by itself, but receives styling
from the parent container. In addition, `Text` will be automatically
placed within the container's layout according to Spectrum guidelines.

See [Button](Button.html#content) for examples of how to use the
`Text` component in the context of a Spectrum container.

## Props

<PropTable component={docs.exports.Text} links={docs.links} />
